module.exports = __webpack_public_path__ + "img/server-04.61402e3b.svg";